<template>
	<div :id="baseId" class="product-perks-panel d-flex flex-column">
		<div class="product-perks-panel-wrapper">
			<div class="slide_header">
				<h1>A Simpler Solution <span>💰</span></h1>
				<h2>No more paying for 5+ different apps! Stan brings it all home.</h2>
			</div>
			<div class="product-perks-panel-content d-flex flex-column">
				<img src="@/assets/images/home/v8/convertkit-auto.png" alt="Simpler Solution" width="600" />
				<TrialButton :show-button-caption="false" class="d-block" buttonClass="trial-btn" where-am-i="creator-store" />
			</div>
		</div>
	</div>
</template>
<script setup>
	import TrialButton from '@/components/shared/TrialButton.vue'
	import { defineProps, computed } from 'vue'
	const props = defineProps({
		id: {
			type: [String, Number],
		},
		activeComponent: { type: Boolean },
	})

	const baseId = computed(() => `${props.id}`)
	const addonId = computed(() => `${props.id}-add-on`)
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/helpers-v6.scss';

	.slide_header {
		margin: 24px auto;
	}

	.product-perks-panel {
		background-color: var(--stan-product-perks-panel-section-background, #f8f7fa);
		font-family: Plus Jakarta Sans, sans-serif;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-bottom: 120px;
		@media (max-width: 767px) {
			& {
				padding-top: 40px;
				overflow: hidden;
			}
		}

		&-wrapper {
			h3,
			p {
				font-family: Plus Jakarta Sans, sans-serif;
				font-style: normal;
				color: #131f60;
			}
			.trial-button {
				margin-top: 4rem;
			}
			h3 {
				font-weight: 800;
				font-size: 36px;
				line-height: 45px;
				text-align: center;
				letter-spacing: -0.01em;
				margin-bottom: 23px;
				@media (max-width: 767px) {
					font-size: 22px;
					line-height: 28px;
					letter-spacing: 0;
					padding-left: 43px;
					padding-right: 45px;
					margin-bottom: 10px;
					margin-left: 0;
					span {
						display: none;
					}
					span + span {
						display: inline-flex !important;
					}
				}
			}

			p {
				font-weight: 500;
				font-size: 20px;
				line-height: 130%;
				text-align: center;
				letter-spacing: -0.01em;
				margin-bottom: 63px;
				@media (max-width: 767px) {
					font-weight: 400;
					font-size: 14px;
					width: 95%;
					padding-left: 40px;
					padding-right: 24px;
					margin-left: 0;
					margin-bottom: 50px;
				}
			}
		}

		&-content,
		&-action {
			display: flex !important;
			justify-content: center;
			align-items: center;
		}

		img {
			box-shadow: 0px 20px 60px rgba(black, 0.1);
			border-radius: 20px;
			height: 72vh;
			margin-bottom: 72px;
			width: auto;
		}

		&-action {
			.panel-button {
				width: 330px;
				height: 75px;
				background: #131f60;
				box-shadow: 0 40px 40px rgba(0, 0, 0, 0.1);
				border: none;
				border-radius: 50px;
				cursor: pointer;
				transition: 0.2s ease;
				&:hover {
					background: #090e2a;
				}
				&-content {
					display: flex;
					align-items: center;
					padding-left: 30px;
					padding-right: 28px;
					padding-bottom: 2px;
					&--text {
						font-family: 'Plus Jakarta Sans', sans-serif;
						font-style: normal;
						font-weight: 600;
						font-size: 22px;
						line-height: 105%;
						color: #ffffff;
						margin-right: auto;
					}
					&--image {
						margin-left: auto;
					}
				}
			}
		}

		@media (max-width: 767px) {
			.slide_header {
				padding-top: 0px;
			}

			& {
				padding-bottom: 72px;
			}
			&-content {
				img {
					width: 90vw;
					max-width: 720px;
					height: auto;
				}
			}
			&-action {
				.panel-button {
					width: 323px;
					height: 60px;
					margin-top: 2rem !important;
					&-content {
						padding-left: 20px;
						padding-right: 18px;
						&--text {
							padding-top: 4px;
							font-size: 16px;
						}
						&--image {
							svg {
								width: 14px;
								height: 14px;
							}
						}
					}
				}
			}
		}
	}
</style>
